module.exports = __webpack_public_path__ + "static/img/pic-join-us.cc14e00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/pic-join-us.png
// module id = 6UfM
// module chunks = 1